(function () {
  /**
   * Phrase i18n for locales beyond en/de/fr.
   * EN/DE/FR use parallel Liquid (cy-lang-*) — do not rewrite those trees.
   * Never destroy motion wrappers (.cy-mo-word / data-cy-mo-split).
   */
  var LANGS = [
    "en", "de", "fr", "zh-CN", "zh-TW", "ja", "ko", "es", "it", "pt-BR", "pt-PT",
    "nl", "pl", "ru", "tr", "vi", "th", "id", "sv", "da", "nb", "fi", "cs", "sk",
    "sl", "hr", "hu", "ro", "bg", "el", "lt"
  ];
  var NATIVE = { en: 1, de: 1, fr: 1 };
  var CACHE = Object.create(null);
  var applying = false;
  var activeDict = null;
  var appliedOnce = false;

  function normalizeLang(raw) {
    if (window.cronylNormalizeLang) return window.cronylNormalizeLang(raw);
    if (!raw) return "en";
    var v = String(raw).trim();
    if (LANGS.indexOf(v) >= 0) return v;
    return "en";
  }

  function assetUrl(lang) {
    return (window.__CRONYL_I18N_ASSETS || {})[lang] || null;
  }

  function normText(s) {
    return String(s || "").replace(/\s+/g, " ").trim();
  }

  function isMotionLocked(el) {
    if (!el || !el.closest) return false;
    return !!(
      el.closest(".cy-mo-word, .cy-mo-split, [data-cy-mo-split='done'], .cy-lang-switch, [data-cy-i18n-skip], script, style, template, noscript, svg")
    );
  }

  function fillPhrases(phrases) {
    if (!phrases) return;

    // Text nodes only — never replace parent innerHTML (protects motion splits & layout)
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      var parent = node.parentElement;
      if (!parent || isMotionLocked(parent)) continue;
      // Only touch visible EN tree when extra locale is active
      if (parent.closest(".cy-lang-de, .cy-lang-fr")) continue;

      var key = node.__cyI18nKey || normText(node.nodeValue);
      if (!key || key.length < 2) continue;
      if (!phrases[key] && !node.__cyI18nKey) continue;
      if (!node.__cyI18nKey) {
        node.__cyI18nKey = key;
        node.__cyLead = (node.nodeValue.match(/^\s*/) || [""])[0];
        node.__cyTail = (node.nodeValue.match(/\s*$/) || [""])[0];
      }
      var next = phrases[node.__cyI18nKey];
      if (next == null) continue;
      var out = (node.__cyLead || "") + next + (node.__cyTail || "");
      if (node.nodeValue !== out) node.nodeValue = out;
    }

    // alt / placeholder / aria-label only
    var attrs = document.querySelectorAll("[alt], [placeholder], [aria-label]");
    for (var i = 0; i < attrs.length; i++) {
      var item = attrs[i];
      if (isMotionLocked(item) || item.closest(".cy-lang-de, .cy-lang-fr")) continue;
      ["alt", "placeholder", "aria-label"].forEach(function (attr) {
        if (!item.hasAttribute(attr)) return;
        if (!item.__cyAttr) item.__cyAttr = {};
        if (!item.__cyAttr[attr]) item.__cyAttr[attr] = normText(item.getAttribute(attr));
        var stored = item.__cyAttr[attr];
        if (stored && phrases[stored]) item.setAttribute(attr, phrases[stored]);
      });
    }
  }

  function applyDict(dict) {
    if (!dict || applying) return;
    applying = true;
    activeDict = dict;
    window.__CRONYL_I18N_DICT = dict;
    try {
      fillPhrases(dict);
      appliedOnce = true;
      document.dispatchEvent(new CustomEvent("cronyl:i18n", { detail: { lang: window.__CRONYL_LANG, dict: dict } }));
    } finally {
      applying = false;
    }
  }

  function loadLang(lang) {
    lang = normalizeLang(lang);
    if (NATIVE[lang]) return Promise.resolve(null);
    if (CACHE[lang]) return Promise.resolve(CACHE[lang]);
    var url = assetUrl(lang);
    if (!url) return Promise.resolve(null);
    return fetch(url, { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data) CACHE[lang] = data;
        return data;
      })
      .catch(function () { return null; });
  }

  window.cronylI18nLangs = LANGS.slice();
  window.cronylT = function (text) {
    if (!activeDict || !text) return text;
    return activeDict[text] || text;
  };

  window.cronylApplyI18n = function (lang) {
    lang = normalizeLang(lang || window.__CRONYL_LANG || "en");
    window.__CRONYL_LANG = lang;
    if (NATIVE[lang]) {
      activeDict = null;
      window.__CRONYL_I18N_DICT = null;
      return Promise.resolve();
    }
    return loadLang(lang).then(function (dict) {
      if (dict) applyDict(dict);
    });
  };

  if (!window.cronylSetLang) {
    window.cronylSetLang = function (lang) {
      lang = normalizeLang(lang);
      try { localStorage.setItem("cronyl_lang", lang); } catch (e) {}
      location.reload();
    };
  }

  (function boot() {
    var lang = normalizeLang(window.__CRONYL_LANG || document.documentElement.getAttribute("data-cy-lang") || "en");
    window.__CRONYL_LANG = lang;
    if (NATIVE[lang]) return;

    function run() {
      // Apply once before motion (both are defer; this script is earlier in document).
      window.cronylApplyI18n(lang);
    }
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", run);
    else run();
  })();
})();
